import React from "react";
import "./printableActivities.scss"; // Estilos específicos para Actividades Imprimibles

//impport elementos de react
import { Row, Col, Pagination } from "react-bootstrap";

//import componentes y vistas
import SubComponent from "../subComponent/subComponent";

//import Imagenes
import printableAzul from "../../img/imgResources/printableAzul.png";
import printableAmar from "../../img/imgResources/printableAmar.png";
import printableRoj from "../../img/imgResources/printableRoj.png";
import printableNaran from "../../img/imgResources/printableNar.png";
import printableVer from "../../img/imgResources/printableVer.png";

import { POST_AXIOS } from "../../components/funtionsREST";

export interface Props {
  Arrayresources: any;
  grade: any;
  subject: any;
}

export default class PrintableActivities extends React.Component<
  Props,
  {
    imagResourcesPrintable: any;
    resources: any;
    currentPage: any;
    elementPage: any;
  }
> {
  constructor(props: any) {
    super(props);
    this.state = {
      imagResourcesPrintable: [
        printableAzul,
        printableAmar,
        printableRoj,
        printableNaran,
        printableVer,
      ],
      resources: this.props.Arrayresources,
      currentPage: 1,
      elementPage: 6,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  // Función que limpia el dominio incorrecto o faltante
  cleanUrl(url: string): string {
    // Verifica si la URL comienza con "www." y no tiene el "https://"
    if (url.startsWith("www.")) {
      return `https://${url}`; // Añade https:// al inicio si falta
    }
    return url; // Si ya tiene el protocolo https://, lo deja intacto
  }

  handleClick(event: any) {
    event.preventDefault();
    this.setState({ currentPage: Number(event.target.id) });
  }

  postProgressResource(resource_id: any) {
    let dataResource = {
      resource_id: resource_id,
    };
    POST_AXIOS("users/newResource", dataResource)
      .then((res) => {
        console.log("Progreso registrado correctamente:", res);
      })
      .catch((err) => {
        console.log("Error al registrar progreso:", err);
      });
    console.log("Nombre del recurso: ", dataResource);
  }

  render() {
    const { resources, currentPage, elementPage, imagResourcesPrintable } =
      this.state;

    //-----------------------------Paginación-----------------------------------
    const indexOfLastTodo = currentPage * elementPage;
    const indexOfFirstTodo = indexOfLastTodo - elementPage;
    const currentResources = resources.slice(indexOfFirstTodo, indexOfLastTodo);

    let active = currentPage;
    let numberPages = Math.ceil(resources.length / elementPage);
    let items = [];
    for (let number = 1; number <= numberPages; number++) {
      items.push(
        <Pagination.Item
          key={number}
          id={number}
          active={number === active}
          onClick={this.handleClick}
        >
          {number}
        </Pagination.Item>
      );
    }

    const paginationBasic = (
      <div>
        <Pagination>{items}</Pagination>
        <br />
      </div>
    );
    //---------------------------------------------------------------------------------
    return (
      <div>
        <Row className="w-100 m-0 h-100 pt-5">
          <Col
            className="justify-content-center align-self-center text-center p-3"
            md={4}
          >
            <div className="af-lineOrange"></div>
          </Col>
          <Col className="m-0 p-0" md={4}>
            <h2 className="af-tittleLesson">Actividades Imprimibles</h2>
          </Col>
          <Col
            className="justify-content-center align-self-center text-center p-3"
            md={4}
          >
            <div className="af-lineOrange"></div>
          </Col>
        </Row>

        <Row>
          <p className="af-textComponent p-4">
            Estas actividades pueden imprimirse, Son ideales para promover el
            aprendizaje activo fuera del entorno digital.
          </p>

          {currentResources.map((resour: any, i: any) => {
            let indexImg = i % 5;
            let cleanResourceUrl = this.cleanUrl(resour.resource_url); // Limpiar la URL
            return (
              <Col key={i} md={4}>
                {/* Llamada a la función de progreso cuando se clica el recurso */}
                <div onClick={() => this.postProgressResource(resour.id)}>
                  <SubComponent
                    tittle={`PA${i + 1 + indexOfFirstTodo}.`}
                    url={cleanResourceUrl}
                    src={imagResourcesPrintable[indexImg]}
                    desc={resour.dba_name}
                  ></SubComponent>
                </div>
              </Col>
            );
          })}

          {resources.length > elementPage && (
            <Row className="w-100 justify-content-center align-self-center text-center">
              {paginationBasic}
            </Row>
          )}
        </Row>
      </div>
    );
  }
}
